import styled from 'styled-components';

export const Container = styled.div`
  height: 70vh;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  img {
    width: 70vh;
  }

  h2 {
    padding: 30px;
    margin-top: 30px;
    text-align: center;
  }

  @media only screen and (max-width: 700px) {
    img {
      width: 40vh;
    }
  }
`;
